module.exports = __webpack_public_path__ + "2575f983f6fbbc7b62433335981605e8.svg";